import React__default, { useContext } from 'react';
import { L as LocalizationContext } from '../../chunks/bundle-BUBY2oxi.js';
import MessageInput from '../../ui/MessageInput.js';
import { u as useOpenChannelContext } from '../../chunks/bundle-FCQ_td66.js';
import '../../chunks/bundle-Cy0THYtw.js';
import '../../chunks/bundle-D1cbmmT1.js';
import '../../chunks/bundle-XjTNuTLb.js';
import '../../chunks/bundle-BUzu_Ent.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-CchwHdkN.js';
import '../../chunks/bundle-DCojCEvj.js';
import 'dompurify';
import '../../chunks/bundle-DoZ7xE0v.js';
import '../../chunks/bundle-C5Boa7rA.js';
import '../../chunks/bundle-BoCmXArP.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-Cy_-UMph.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-BEAYXWFj.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-0XYk-sLK.js';
import '../../chunks/bundle-3PybmMNj.js';
import '../../chunks/bundle-Dp84Y5uU.js';
import '../../chunks/bundle-o7vwnDXb.js';
import '../../chunks/bundle-CqpHzVax.js';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-CTudsbOB.js';
import 'react-dom';
import '../../chunks/bundle-Dmf3WkDZ.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../../chunks/bundle-BaAr93_S.js';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-C0hZDj23.js';
import '../../chunks/bundle-CNJeg2pQ.js';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-DTwlSMhz.js';
import '../../chunks/bundle-CuQrZUbT.js';
import '../../chunks/bundle-_ABtTUTZ.js';
import '../../chunks/bundle-D-NnXvbs.js';

var OpenChannelInput = React__default.forwardRef(function (props, ref) {
    var _a = useOpenChannelContext(), currentOpenChannel = _a.currentOpenChannel, disabled = _a.disabled, handleSendMessage = _a.handleSendMessage, handleFileUpload = _a.handleFileUpload, amIMuted = _a.amIMuted;
    var channel = currentOpenChannel;
    var stringSet = useContext(LocalizationContext).stringSet;
    var value = props.value;
    function getPlaceHolderString() {
        if (amIMuted) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__MUTED;
        }
        if (disabled) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__DISABLED;
        }
        return '';
    }
    if (!channel) {
        return null;
    }
    return (React__default.createElement("div", { className: "sendbird-openchannel-footer" },
        React__default.createElement(MessageInput, { channel: currentOpenChannel, ref: ref, value: value, disabled: disabled, isVoiceMessageEnabled: false, onSendMessage: handleSendMessage, onFileUpload: handleFileUpload, placeholder: getPlaceHolderString() })));
});

export { OpenChannelInput as default };
//# sourceMappingURL=OpenChannelInput.js.map
